import React from 'react';

// components
import FieldCheckbox from 'components/UiKit/FieldCheckbox';

// Interface
interface ISubHeaderList {
	checkboxAll: boolean;
	handleChangeCheckboxAll: () => void;
}

export const SubHeaderList: React.FC<ISubHeaderList> = (props) => {
	const { checkboxAll, handleChangeCheckboxAll } = props;
	return (
		<div className="pfizer__sub-header-list flex flex-ai-center flex-jc-start full-width">
			<FieldCheckbox
				readOnly
				label="All"
				className=""
				value={checkboxAll}
				name="checkboxItemAll"
				onChange={handleChangeCheckboxAll}
			/>
			<p className="pfizer__sub-header-list-title pfizer__col-1">
				ID
			</p>
			<p className="pfizer__sub-header-list-title pfizer__col-2">
				CAS
			</p>
			<p className="pfizer__sub-header-list-title pfizer__col-3">
				Name
			</p>
			<p className="pfizer__sub-header-list-title pfizer__col-4">
				Price
			</p>
			<p className="pfizer__sub-header-list-title pfizer__col-5">
				Quantity
			</p>
		</div>
	);
};

export default SubHeaderList;
